<template>
  <div>
    <div id="popupBackground">
      <div @click="onDialogClose" id="triggerClick" aria-hidden="true"></div>
      <vx-card
        ref="dialog"
        role="dialog"
        aria-modal="true"
        :aria-label="videoTitle ? `Video: ${videoTitle}` : 'Video player'"
        id="videoPopup"
      >
        <div tabindex="0" data-focus-sentinel @focus="focusLastInDialog"></div>
        <div class="flex flex-row-reverse">
          <vs-button
            aria-label="Close video"
            size="large"
            type="flat"
            icon="close"
            @click="onDialogClose"
          />
        </div>
        <VuePlyr :options="plyrOptions">
          <!-- No `crossorigin` here on purpose - see mixins/captionedVideo.js. -->
          <video controls playsinline autoplay="1" allow="autoplay">
            <source :src="videoSrc" type="video/mp4" />
            <!-- Captions (SC 1.2.2): the .vtt beside the MP4, or one the caller passed. -->
            <track
              v-if="captionsUrl"
              kind="captions"
              label="English"
              srclang="en"
              :src="captionsUrl"
              default
              @load="onCaptionsLoad"
              @error="onCaptionsError"
            />
          </video>
        </VuePlyr>
        <!-- Text alternative for the video (SC 1.2.3): supplied by the caller, or built
             from the caption cues once they have loaded. -->
        <details v-if="videoTranscript || transcriptText" class="video-transcript mt-3">
          <summary>Video transcript</summary>
          <div v-if="videoTranscript" class="mt-2" v-html="videoTranscript"></div>
          <p v-else class="mt-2">{{ transcriptText }}</p>
        </details>

        <div tabindex="0" data-focus-sentinel @focus="focusFirstInDialog"></div>
      </vx-card>
    </div>
  </div>
</template>
<script>
import store from '@/store/store';
import { mapGetters } from 'vuex';
import dialogMixin from '@/mixins/dialog';
import captionedVideo from '@/mixins/captionedVideo';

export default {
  mixins: [dialogMixin, captionedVideo],
  props: {
    src: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      // Show captions as soon as they load; the CC button still lets users hide them.
      plyrOptions: { captions: { active: true, language: 'en', update: true } },
    };
  },
  methods: {
    onDialogClose() {
      // Where a caller named the trigger explicitly, prefer it over the element that
      // happened to hold focus when the dialog opened; the mixin restores either on
      // teardown, so focus is only moved in one place.
      const elem = document.getElementById(this.focusElemOnPopupClose);
      if (elem) {
        this.dialogReturnFocusTo = elem;
        store.commit('popup/setFocusElemOnPopupClose', null);
      }
      store.commit('popup/setVideoPopupVisible', false);
    },
  },
  computed: {
    ...mapGetters({
      focusElemOnPopupClose: 'popup/getFocusElemOnPopupClose',
    }),
    videoSrc() {
      return this.$store.getters['popup/videoPopupSrc'];
    },
    videoTitle() {
      return this.$store.getters['popup/videoPopupTitle'];
    },
    videoTranscript() {
      return this.$store.getters['popup/videoPopupTranscript'];
    },
    // Inputs for the captionedVideo mixin.
    videoSourceUrl() {
      return this.videoSrc;
    },
    explicitCaptions() {
      return this.$store.getters['popup/videoPopupCaptions'];
    },
    explicitTranscript() {
      return this.videoTranscript;
    },
    videoPopupVisible() {
      return this.$store.getters['popup/videoPopupVisible'];
    },
  },
};
</script>
<style scoped>
#videoPopup {
  position: fixed;
  top: 10%;
  width: 60%;
  left: 20%;
}
video {
  width: 100%;
  height: auto;
}
#popupBackground {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 99999;
}
#popupBackground #triggerClick {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
@media screen and (max-width: 768px) {
  #videoPopup {
    top: 10%;
    width: 94%;
    left: 3%;
  }
}
</style>
